import { defineComponent as _defineComponent } from 'vue'
import { useAuthenticationStore } from "@/stores/authentication";

import TheNavbarHelp from "./TheNavbarHelp.vue";
import TheNavbarMenu from "./TheNavbarMenu.vue";
import TheNavbarUserMenu from "./TheNavbarUserMenu.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TheNavbar',
  setup(__props) {

const authStore = useAuthenticationStore();

return { __sfc: true,authStore, TheNavbarHelp, TheNavbarMenu, TheNavbarUserMenu }
}

})